import { render } from "./FilterOrderBevestiging.vue?vue&type=template&id=197f1f12&scoped=true"
import script from "./FilterOrderBevestiging.vue?vue&type=script&lang=js"
export * from "./FilterOrderBevestiging.vue?vue&type=script&lang=js"

import "./FilterOrderBevestiging.vue?vue&type=style&index=0&id=197f1f12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197f1f12"]])

export default __exports__